// *******************************************************************************
// Forgotten password form validation
// *******************************************************************************

document.addEventListener('DOMContentLoaded', () => {
  const forgottenPasswordForm = document.querySelector('.forgotten-password form');
  if (forgottenPasswordForm) {
    let errorMessage1 = '';
    let errorMessage2 = '';
    let firstField = 'email';
    if (forgottenPasswordForm.querySelector('[name="password_0"]') && forgottenPasswordForm.querySelector('[name="password_1"]')) {
      errorMessage1 = forgottenPasswordForm.querySelector('[name="password_0"]').getAttribute('data-error-message');
      errorMessage2 = forgottenPasswordForm.querySelector('[name="password_1"]').getAttribute('data-error-message');
      firstField = 'password_0';
    }
    if (forgottenPasswordForm) {
      const fv = FormValidation.formValidation(forgottenPasswordForm, {
        locale: 'sl_SI',
        localization: FormValidation.locales.sl_SI,
        fields: {
          password_0: {
            validators: {
              regexp: {
                regexp: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/g,
                message: errorMessage1,
              },
            },
          },
          password_1: {
            validators: {
              identical: {
                compare() {
                  return forgottenPasswordForm.querySelector('[name="password_0"]').value;
                },
                message: errorMessage2,
              },
            },
          },
        },
        plugins: {
          message: new FormValidation.plugins.Message({
            container: (field, element) => element.closest('.forgotten-password__inputs,.checkbox'),
          }),
          declarative: new FormValidation.plugins.Declarative({
            html5Input: true,
          }),
          trigger: new FormValidation.plugins.Trigger(),
          submitButton: new FormValidation.plugins.SubmitButton(),
        },
      }).on('core.form.valid', () => {
        forgottenPasswordForm.querySelector('.forgotten-password__error').classList.remove('is-validation-failed');
        const formData = {};
        forgottenPasswordForm.querySelectorAll('input, textarea').forEach((input) => {
          formData[input.name] = input.value.trim();
        });
        grecaptcha.ready(() => {
          grecaptcha.execute(localData.captchaSiteKey, { action: formData.action }).then((token) => {
            const formDataImage = new FormData();
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            formDataImage.append('action', formData.forgotten_password_action);
            formDataImage.append('inputs', JSON.stringify(formData));
            formDataImage.append('lang', localData.lang);
            formDataImage.append('id', localData.id);
            formDataImage.append('token', token);
            formDataImage.append('user_id', urlParams.get('user_id'));
            formDataImage.append('wp_token', urlParams.get('wp_token'));
            axios
              .post(localData.siteURL, formDataImage, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              })
              .then((response) => {
                if (response.status === 200 && response.data.data.url) {
                  window.location = response.data.data.url;
                } else if (response.status === 200 && response.data.data.msg) {
                  forgottenPasswordForm.innerHTML = `<div>${response.data.data.msg}</div>`;
                  forgottenPasswordForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
              })
              .catch((error) => {
                forgottenPasswordForm.querySelector('.forgotten-password__error').classList.add('is-validation-failed');
                console.error(error);
              });
          });
        });
      });
    }
  }
});
